import { render, staticRenderFns } from "./Pos_my_order_list.vue?vue&type=template&id=da5844e2&scoped=true&"
import script from "./Pos_my_order_list.vue?vue&type=script&lang=js&"
export * from "./Pos_my_order_list.vue?vue&type=script&lang=js&"
import style0 from "./Pos_my_order_list.vue?vue&type=style&index=0&id=da5844e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5844e2",
  null
  
)

export default component.exports